import { Platform, StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  scrollViewContentStyle: withTray => ({
    paddingTop: 15,
    paddingBottom: withTray ? 240 : 160,
    paddingHorizontal: 16,
  }),
  titleStyle: {
    fontSize: 25,
    lineHeight: 31.2,
    marginBottom: 16,
    marginTop: Platform.OS === 'android' ? 14.4 : 10.4,
    ...Fonts.type.bold,
  },
  subHeaderTitle: {
    paddingTop: 15,
    paddingBottom: 4,
  },
  headerTitleStyle: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25.1,
  },
  amountStyle: {
    fontSize: 25,
    ...Fonts.type.bold,
    marginTop: 8,
  },
  unitStyle: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 20,
    marginTop: 12,
    color: Colors.smoothGreyTwo,
    ...Platform.select({
      ios: {
        marginTop: 12,
      },
      android: {
        marginTop: 9,
      },
    }),
  },
  productIdStyle: {
    fontSize: 16,
    lineHeight: 22,
    marginTop: 16,
    letterSpacing: 0,
    color: Colors.lightGreyTwo,
  },
  unitAmountContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  errorIconStyle: {
    marginTop: 50,
  },
  confirmButtonStyle: { marginTop: 8, marginHorizontal: 16 },

  containerStyle: theme => ({
    borderRadius: 6.2,
    paddingTop: 16,
    paddingBottom: 24,
    backgroundColor: theme.colors.cardBackgroundColor,
    ...cardShadow,
  }),
});
